import deep from 'deep-get-set';
import { createAction } from 'redux-api-middleware';
import { createSelector } from 'reselect';
import config from '@src/config';
import crakIds from '@src/constants/crak';
import elementTypeIds, { SUBMISSION_TYPES } from '@src/constants/element-types';
import { CAMPAIGN_ELEMENT_SORT_LIST, GENERIC_ELEMENT_SORT_LIST } from '@src/constants/sortLists';
import {
  getFullMediaUrlFromPresignedUrl,
  getPathFromFullMediaUrl,
} from '@src/utils/getFullMediaUrlFromPresignedUrl';
import { buildHeaders } from '@src/redux/buildAuthHeader';
import { getAllLanguages } from '@src/translations/dictionary';

export const CAMPAIGN_EDIT_INFO_LOAD = 'CAMPAIGN_EDIT_INFO_LOAD';
export const CAMPAIGN_EDIT_INFO_LOAD_SUCCESS = 'CAMPAIGN_EDIT_INFO_LOAD_SUCCESS';
export const CAMPAIGN_EDIT_INFO_LOAD_FAILURE = 'CAMPAIGN_EDIT_INFO_LOAD_FAILURE';
export const CAMPAIGN_INFO_PUBLISH = 'CAMPAIGN_INFO_PUBLISH';
export const CAMPAIGN_INFO_PREVIEW = 'CAMPAIGN_INFO_PREVIEW';
export const CAMPAIGN_INFO_RESET = 'CAMPAIGN_INFO_RESET';
export const CAMPAIGN_NAME_EDIT = 'CAMPAIGN_NAME_EDIT';
export const CAMPAIGN_ELEMENT_MOVE_UP = 'CAMPAIGN_ELEMENT_MOVE_UP';
export const CAMPAIGN_ELEMENT_MOVE_DOWN = 'CAMPAIGN_ELEMENT_MOVE_DOWN';
export const CAMPAIGN_ELEMENT_SAVE = 'CAMPAIGN_ELEMENT_SAVE';
export const CAMPAIGN_ELEMENT_ADD = 'CAMPAIGN_ELEMENT_ADD';
export const CAMPAIGN_ELEMENT_DELETE = 'CAMPAIGN_ELEMENT_DELETE';
export const CAMPAIGN_ELEMENT_LABEL_UPDATE = 'CAMPAIGN_ELEMENT_LABEL_UPDATE';
export const CAMPAIGN_ELEMENT_ALLOWED_VALUES_UPDATE = 'CAMPAIGN_ELEMENT_ALLOWED_VALUES_UPDATE';
export const CAMPAIGN_ELEMENT_TYPE_LABELS_UPDATE = 'CAMPAIGN_ELEMENT_TYPE_LABELS_UPDATE';
export const CAMPAIGN_ELEMENT_TYPE_DESCRIPTIONS_UPDATE = 'CAMPAIGN_ELEMENT_TYPE_DESCRIPTIONS_UPDATE';
export const CAMPAIGN_ELEMENT_REQUIRED_UPDATE = 'CAMPAIGN_ELEMENT_REQUIRED_UPDATE';
export const CAMPAIGN_DESCRIPTION_UPDATE = 'CAMPAIGN_DESCRIPTION_UPDATE';
export const CAMPAIGN_FORM_DIRTY_SET = 'CAMPAIGN_FORM_DIRTY_SET';
export const CAMPAIGN_FORM_INFO_SAVE = 'CAMPAIGN_FORM_INFO_SAVE';
export const CAMPAIGN_FORM_INFO_SAVE_FAILURE = 'CAMPAIGN_FORM_INFO_SAVE_FAILURE';
export const CAMPAIGN_FORM_INFO_SAVE_SUCCESS = 'CAMPAIGN_FORM_INFO_SAVE_SUCCESS';
export const VIDEO_LANDING_PAGE_MODAL_SHOW = 'VIDEO_LANDING_PAGE_MODAL_SHOW';
export const VIDEO_LANDING_PAGE_MODAL_HIDE = 'VIDEO_LANDING_PAGE_MODAL_HIDE';
export const CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE = 'CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE';
export const CAMPAIGN_ELEMENT_TYPES_LOAD = 'CAMPAIGN_ELEMENT_TYPES_LOAD';
export const CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS = 'CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS';
export const CRAKS_LOAD = 'CRAKS_LOAD';
export const CRAKS_LOAD_FAILURE = 'CRAKS_FAILURE';
export const CRAKS_LOAD_SUCCESS = 'CRAKS_LOAD_SUCCESS';

export const VIDEO_ELEMENT_UPLOADED_STATUS_CLEAR = 'VIDEO_ELEMENT_UPLOADED_STATUS_CLEAR';
export const VIDEO_ELEMENT_RECORDING_COMPLETE = 'VIDEO_ELEMENT_RECORDING_COMPLETE';
export const VIDEO_ELEMENT_CAMERA_RECORDER_SHOW = 'VIDEO_ELEMENT_CAMERA_RECORDER_SHOW';
export const VIDEO_ELEMENT_CAMERA_RECORDER_HIDE = 'VIDEO_ELEMENT_CAMERA_RECORDER_HIDE';
export const VIDEO_ELEMENT_VIDEO_SELECT = 'VIDEO_ELEMENT_VIDEO_SELECT';
export const VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_LOAD = 'VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_LOAD';
export const VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_FAILURE =
  'VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_FAILURE';
export const VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_SUCCESS =
  'VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_SUCCESS';
export const VIDEO_ELEMENT_BUCKET_UPLOAD_LOAD = 'VIDEO_ELEMENT_BUCKET_UPLOAD_LOAD';
export const VIDEO_ELEMENT_BUCKET_UPLOAD_FAIL = 'VIDEO_ELEMENT_BUCKET_UPLOAD_FAIL';
export const VIDEO_ELEMENT_BUCKET_UPLOAD_SUCCESS = 'VIDEO_ELEMENT_BUCKET_UPLOAD_SUCCESS';
export const VIDEO_ELEMENT_MEDIA_TYPE_SET = 'VIDEO_ELEMENT_MEDIA_TYPE_SET';
export const VIDEO_ELEMENT_POST_ACTION_CANCEL = 'VIDEO_ELEMENT_POST_ACTION_CANCEL';

export const CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_LOAD =
  'CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_LOAD';
export const CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_FAILURE =
  'CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_FAILURE';
export const CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_SUCCESS =
  'CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_SUCCESS';
export const CAMPAIGN_EDIT_BUCKET_UPLOAD_LOAD = 'CAMPAIGN_EDIT_BUCKET_UPLOAD_LOAD';
export const CAMPAIGN_EDIT_BUCKET_UPLOAD_SUCCESS = 'CAMPAIGN_EDIT_BUCKET_UPLOAD_SUCCESS';
export const CAMPAIGN_EDIT_BUCKET_UPLOAD_FAIL = 'CAMPAIGN_EDIT_BUCKET_UPLOAD_FAIL';

export const IMAGE_ELEMENT_FILE_SELECT = 'IMAGE_ELEMENT_FILE_SELECT';
export const IMAGE_ELEMENT_LOAD_IMAGE = 'IMAGE_ELEMENT_LOAD_IMAGE';
export const IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE = 'IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE';
export const IMAGE_ELEMENT_SAVE_EDITED_IMAGE = 'IMAGE_ELEMENT_SAVE_EDITED_IMAGE';
export const IMAGE_ELEMENT_RESET = 'IMAGE_ELEMENT_RESET';

export const CAMPAIGN_SUCESS_PAGE_ENABLED_SET = 'CAMPAIGN_SUCESS_PAGE_ENABLED_SET';
export const CAMPAIGN_SUCCESS_MODAL_HIDE = 'CAMPAIGN_SUCCESS_MODAL_HIDE';
export const CAMPAIGN_SUCCESS_MODAL_SHOW = 'CAMPAIGN_SUCCESS_MODAL_SHOW';
export const CAMPAIGN_SUCCESS_PAGE_CREATE = 'CAMPAIGN_SUCCESS_PAGE_CREATE';
export const CAMPAIGN_SUCCESS_PAGE_CREATE_FAIL = 'CAMPAIGN_SUCCESS_PAGE_CREATE_FAIL';
export const CAMPAIGN_SUCCESS_PAGE_CREATE_SUCCESS = 'CAMPAIGN_SUCCESS_PAGE_CREATE_SUCCESS';
export const CAMPAIGN_SUCCESS_PAGE_UPDATE = 'CAMPAIGN_SUCCESS_PAGE_UPDATE';
export const CAMPAIGN_SUCCESS_PAGE_UPDATE_FAIL = 'CAMPAIGN_SUCCESS_PAGE_UPDATE_FAIL';
export const CAMPAIGN_SUCCESS_PAGE_UPDATE_SUCCESS = 'CAMPAIGN_SUCCESS_PAGE_UPDATE_SUCCESS';
export const CAMPAIGN_SUCESS_PAGE_USE_REDIRECT = 'CAMPAIGN_SUCESS_PAGE_USE_REDIRECT';
export const CAMPAIGN_SUCESS_PAGE_VALIDATION_ERROR_SET =
  'CAMPAIGN_SUCESS_PAGE_VALIDATION_ERROR_SET';
export const CAMPAIGN_SUCESS_PAGE_REDIRECT_SET = 'CAMPAIGN_SUCESS_PAGE_REDIRECT_SET';
export const CAMPAIGN_SUCCESS_PAGE_REDIRECT_SET_V2 = 'CAMPAIGN_SUCCESS_PAGE_REDIRECT_SET_V2';
export const SET_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT = 'SET_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT';
export const INIT_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT = 'INIT_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT';
export const SET_CAMPAIGN_SUBMIT_STATE = 'SET_CAMPAIGN_SUBMIT_STATE';

export const CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_LOAD =
  'CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_LOAD';
export const CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_FAILURE =
  'CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_FAILURE';
export const CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_SUCCESS =
  'CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_SUCCESS';
export const CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_LOAD = 'CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_LOAD';
export const CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS =
  'CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS';
export const CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS_V2 =
  'CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS_V2';
export const CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_FAIL = 'CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_FAIL';

export const CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_FILE_SELECT =
  'CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_FILE_SELECT';
export const CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_LOAD_IMAGE =
  'CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_LOAD_IMAGE';
export const CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE =
  'CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE';
export const CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_SAVE_EDITED_IMAGE =
  'CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_SAVE_EDITED_IMAGE';
export const CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_RESET =
  'CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_RESET';

export const CAMPAIGN_TERMS_UPDATE_LOAD = 'CAMPAIGN_TERMS_UPDATE_LOAD';
export const CAMPAIGN_TERMS_UPDATE_FAILURE = 'CAMPAIGN_TERMS_UPDATE_FAILURE';
export const CAMPAIGN_TERMS_UPDATE_SUCCESS = 'CAMPAIGN_TERMS_UPDATE_SUCCESS';
export const CAMPAIGN_TERMS_FETCH_LOAD = 'CAMPAIGN_TERMS_FETCH_LOAD';
export const CAMPAIGN_TERMS_FETCH_FAILURE = 'CAMPAIGN_TERMS_FETCH_FAILURE';
export const CAMPAIGN_TERMS_FETCH_SUCCESS = 'CAMPAIGN_TERMS_FETCH_SUCCESS';
export const CAMPAIGN_TERMS_RESET = 'CAMPAIGN_TERMS_RESET';

export const DOWNLOAD_RESPONSES_MODAL_SHOW = 'DOWNLOAD_RESPONSES_MODAL_SHOW';
export const DOWNLOAD_RESPONSES_MODAL_HIDE = 'DOWNLOAD_RESPONSES_MODAL_HIDE';

export const CAMPAIGN_CSV_RESPONSES_LOAD = 'CAMPAIGN_CSV_RESPONSES_LOAD';
export const CAMPAIGN_CSV_RESPONSES_LOAD_FAIL = 'CAMPAIGN_CSV_RESPONSES_LOAD_FAIL';
export const CAMPAIGN_CSV_RESPONSES_LOAD_SUCCESS = 'CAMPAIGN_CSV_RESPONSES_LOAD_SUCCESS';
export const CLEAR_CSV_RESPONSES_DATA = 'CLEAR_CSV_RESPONSES_DATA';

export const SET_EDITED_STATE = 'SET_EDITED_STATE';
export const SET_FINISHED_LOADING_STATE = 'SET_FINISHED_LOADING_STATE';
export const SET_IS_NEW_TEMPLATE_CREATION = 'SET_IS_NEW_TEMPLATE_CREATION';
export const CAMPAIGN_THANK_YOU_SOCIAL_EDIT = 'CAMPAIGN_THANK_YOU_SOCIAL_EDIT';

// CAMPAIGN BRANDING
export const CAMPAIGN_BANNER_EDIT = 'CAMPAIGN_BANNER_EDIT';
export const CAMPAIGN_TITLE_FONT_COLOR_EDIT = 'CAMPAIGN_TITLE_FONT_COLOR_EDIT';
export const CAMPAIGN_USE_BANNER_EDIT = 'CAMPAIGN_USE_BANNER_EDIT';
export const CAMPAIGN_LOGO_EDIT = 'CAMPAIGN_LOGO_EDIT';
export const CAMPAIGN_USE_LOGO_EDIT = 'CAMPAIGN_USE_LOGO_EDIT';
export const CAMPAIGN_USE_PROFILE_EDIT = 'CAMPAIGN_USE_PROFILE_EDIT';
export const CAMPAIGN_PROFILE_EDIT = 'CAMPAIGN_PROFILE_EDIT';
export const CAMPAIGN_BRAND_TITLE_EDIT = 'CAMPAIGN_BRAND_TITLE_EDIT';
export const CAMPAIGN_BRAND_NAME_EDIT = 'CAMPAIGN_BRAND_NAME_EDIT';

// CAMPAIGN BRANDING ASSET MANAGING
export const CAMPAIGN_LOAD_IMAGE_FILE = 'CAMPAIGN_LOAD_IMAGE_FILE';
export const CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_SUCCESS =
  'CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_SUCCESS';
export const CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_LOAD =
  'CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_LOAD';
export const CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_FAIL =
  'CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_FAIL';
export const CAMPAIGN_BRANDING_BUCKET_UPLOAD_SUCCESS = 'CAMPAIGN_BRANDING_BUCKET_UPLOAD_SUCCESS';
export const CAMPAIGN_BRANDING_BUCKET_UPLOAD_LOAD = 'CAMPAIGN_BRANDING_BUCKET_UPLOAD_LOAD';
export const CAMPAIGN_BRANDING_BUCKET_UPLOAD_FAIL = 'CAMPAIGN_BRANDING_BUCKET_UPLOAD_FAIL';

// SEO SETTINGS
export const SEO_SETTINGS_SET_DESCRIPTION = 'SEO_SETTINGS_SET_DESCRIPTION';
export const SEO_SETTINGS_SET_SITE_NAME = 'SEO_SETTINGS_SET_SITE_NAME';

export const MULTIPLE_CHOICE_ADD_OPTION = 'MULTIPLE_CHOICE_ADD_OPTION';
export const MULTIPLE_CHOICE_REMOVE_OPTION = 'MULTIPLE_CHOICE_REMOVE_OPTION';
export const MULTIPLE_CHOICE_EDIT_OPTION = 'MULTIPLE_CHOICE_EDIT_OPTION';
export const MULTIPLE_CHOICE_REORDER_OPTIONS = 'MULTIPLE_CHOICE_REORDER_OPTIONS';

export const MULTIPLE_CHOICE_MAX_OPTIONS = 100;

export const LANGUAGE_SETTINGS_SET = 'LANGUAGE_SETTINGS_SET';

export const PUBLIC_SUBMISSION_SETTINGS_SET = 'PUBLIC_SUBMISSION_SETTINGS_SET';

export const CAMPAIGN_REWARD_SETTINGS_SET = 'CAMPAIGN_REWARD_SETTINGS_SET';

export const GIFT_CARD_HISTORY_LOAD = 'GIFT_CARD_HISTORY_LOAD';
export const GIFT_CARD_HISTORY_LOAD_SUCCESS = 'GIFT_CARD_HISTORY_LOAD_SUCCESS';
export const GIFT_CARD_HISTORY_LOAD_FAILURE = 'GIFT_CARD_HISTORY_LOAD_FAILURE';

export const CEP_SET_VLP_CTA_LABEL = 'CEP_SET_VLP_CTA_LABEL';
export const CEP_SET_VLP_CTA_LINK = 'CEP_SET_VLP_CTA_LINK';

export const AUTO_TAGS_SET = 'AUTO_TAGS_SET';
export const END_DATE_SET = 'END_DATE_SET';

// Action helpers
function pluckLabelFields(element) {
  const isMultipleChoice = element.crakId === crakIds.MULTIPLE_CHOICE || element.crakId === crakIds.AUTOTAG_INPUT;

  return {
    id: element.id,
    label: element.label,
    description: isMultipleChoice ? element?.choices?.toString() || '' : element.description,
    siteName: element.seoSiteName,
    elementTypeId: element.elementTypeId,
    mediaUrl: element.mediaUrl && getPathFromFullMediaUrl(element.mediaUrl),
    crakId: element.crakId,
    required: element.required,
    isDeleted: element.isDeleted,
    mediaSubmissionId: element.preSignedUrlData?.mediaSubmissionId,
    allowedValues: element?.allowedValues,
    typeLabels: element?.typeLabels,
    typeDescriptions: element?.typeDescriptions,
  };
}

function mapCampaignBrandingPayload(payload) {
  return {
    banner: payload?.banner,
    useBanner: payload?.useBanner,
    logo: payload?.logo,
    useLogo: payload?.useLogo,
    profile: payload?.profile,
    useProfile: payload?.useProfile,
    name: payload?.name,
    title: payload?.title,
    fontColor: payload?.fontColor,
    ctaLabel: payload?.ctaLabel,
    ctaLink: payload?.ctaLink,
  };
}

function buildSparsePayload(payload) {
  return {
    name: payload.name,
    description: payload.seoDescription,
    siteName: payload.seoSiteName,
    campaignBranding: mapCampaignBrandingPayload(payload?.campaignBranding),
    campaignDomain: payload.campaignDomain,
    campaignElements: payload?.campaignElements
      ?.map(pluckLabelFields)
      ?.concat(
        payload?.deletedElements?.filter((el) => el?.id && el?.isDeleted)?.map(pluckLabelFields)
      ),
    language: payload?.language,
    autotags: payload?.autotags?.filter(tag => tag !== ""),
    publicCampaignSubmission: payload?.publicCampaignSubmission,
    rewardSettings: payload?.rewardSettings,
    endDate: typeof payload?.endDate !== 'undefined' ? payload.endDate : undefined,
  };
}

// Action creators
export const fetchCampaignEditInfo = (campaignLink) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.publicCampaignInfo}${campaignLink}`,
    credentials: 'include',
    method: 'GET',
    headers: buildHeaders(),
    types: [
      CAMPAIGN_EDIT_INFO_LOAD,
      CAMPAIGN_EDIT_INFO_LOAD_SUCCESS,
      CAMPAIGN_EDIT_INFO_LOAD_FAILURE,
    ],
  });

export const saveCampaignFormInfo = (campaignId, payload) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.publicCampaignInfo}${campaignId}`,
    credentials: 'include',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(buildSparsePayload(payload)),
    types: [
      CAMPAIGN_FORM_INFO_SAVE,
      CAMPAIGN_FORM_INFO_SAVE_SUCCESS,
      CAMPAIGN_FORM_INFO_SAVE_FAILURE,
    ],
  });

export const fetchCampaignElementTypes = () =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignElementTypes}`,
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: [
      CAMPAIGN_ELEMENT_TYPES_LOAD,
      CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS,
      CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE,
    ],
  });

export const fetchCraks = () =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignResponseKeys}`,
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: [CRAKS_LOAD, CRAKS_LOAD_SUCCESS, CRAKS_LOAD_FAILURE],
  });

// GET a new PreSigned URL for uploading file to S3
export const createAssetPresignedUrl = (elementIndex) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.preSignCampaignElementImageForS3}`,
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: [
      CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_LOAD,
      {
        type: CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_SUCCESS,
        meta: { elementIndex },
      },
      {
        type: CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_FAILURE,
        meta: { elementIndex },
      },
    ],
  });

export const createBrandingAssetPresignedUrl = ({ isLogo }) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.preSignCampaignElementImageForS3}`,
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: [
      { type: CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_LOAD, meta: { isLogo } },
      {
        type: CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_SUCCESS,
        meta: { isLogo },
      },
      {
        type: CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_FAIL,
        meta: { isLogo },
      },
    ],
  });

export const uploadAssetToBucket = (file, preSignedUrl, elementIndex) =>
  createAction({
    endpoint: preSignedUrl,
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': 'public-read',
    },
    body: file,
    types: [
      CAMPAIGN_EDIT_BUCKET_UPLOAD_LOAD,
      {
        type: CAMPAIGN_EDIT_BUCKET_UPLOAD_SUCCESS,
        meta: { elementIndex },
      },
      {
        type: CAMPAIGN_EDIT_BUCKET_UPLOAD_FAIL,
        meta: { elementIndex },
      },
    ],
  });

export const fetchCampaignTerms = (endpoint) =>
  createAction({
    endpoint,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [CAMPAIGN_TERMS_FETCH_LOAD, CAMPAIGN_TERMS_FETCH_SUCCESS, CAMPAIGN_TERMS_FETCH_FAILURE],
  });

export const fetchCampaignCsvResponses = (campaignId) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignDownloadResponsesCsv}/${campaignId}`,
    credentials: 'include',
    method: 'GET',
    headers: buildHeaders(),
    types: [
      CAMPAIGN_CSV_RESPONSES_LOAD,
      CAMPAIGN_CSV_RESPONSES_LOAD_SUCCESS,
      CAMPAIGN_CSV_RESPONSES_LOAD_FAIL,
    ],
  });

export const createCampaignTerm = (payload) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.terms}`,
    credentials: 'include',
    method: 'POST',
    headers: buildHeaders(),
    body: JSON.stringify(payload),
    types: [
      CAMPAIGN_TERMS_UPDATE_LOAD,
      CAMPAIGN_TERMS_UPDATE_SUCCESS,
      CAMPAIGN_TERMS_UPDATE_FAILURE,
    ],
  });

export const updateCampaignTerm = (payload, uuid) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.terms}/${uuid}`,
    credentials: 'include',
    method: 'PUT',
    headers: buildHeaders(),
    body: JSON.stringify(payload),
    types: [
      CAMPAIGN_TERMS_UPDATE_LOAD,
      CAMPAIGN_TERMS_UPDATE_SUCCESS,
      CAMPAIGN_TERMS_UPDATE_FAILURE,
    ],
  });

export function updateCampaignName(name) {
  return {
    type: CAMPAIGN_NAME_EDIT,
    name,
  };
}

export function updateCampaignBanner(banner) {
  return {
    type: CAMPAIGN_BANNER_EDIT,
    banner,
  };
}

export function updateCampaignTitleFontColor(value) {
  return {
    type: CAMPAIGN_TITLE_FONT_COLOR_EDIT,
    value,
  };
}

export function updateUseCampaignBanner(value) {
  return {
    type: CAMPAIGN_USE_BANNER_EDIT,
    value,
  };
}

export function updateCampaignBrandTitle(value) {
  return {
    type: CAMPAIGN_BRAND_TITLE_EDIT,
    value,
  };
}

export function updateCampaignBrandName(value) {
  return {
    type: CAMPAIGN_BRAND_NAME_EDIT,
    value,
  };
}

export function updateCampaignLogo(logo) {
  return {
    type: CAMPAIGN_LOGO_EDIT,
    logo,
  };
}

export function updateUseCampaignLogo(value) {
  return {
    type: CAMPAIGN_USE_LOGO_EDIT,
    value,
  };
}

export function updateUseCampaignLoadingImage({ file, isLogo }) {
  return {
    type: CAMPAIGN_LOAD_IMAGE_FILE,
    file,
    isLogo,
  };
}

export function updateCampaignProfile(profileImage) {
  return {
    type: CAMPAIGN_PROFILE_EDIT,
    profileImage,
  };
}

export function updateUseCampaignProfile(value) {
  return {
    type: CAMPAIGN_USE_PROFILE_EDIT,
    value,
  };
}

export function addNewElement(element) {
  return {
    type: CAMPAIGN_ELEMENT_ADD,
    element,
  };
}

export function deleteElement(index) {
  return {
    type: CAMPAIGN_ELEMENT_DELETE,
    index,
  };
}

export function updateLabel(index, label) {
  return {
    type: CAMPAIGN_ELEMENT_LABEL_UPDATE,
    index,
    label,
  };
}

export const updateAllowedValues = (index, values) => ({
  type: CAMPAIGN_ELEMENT_ALLOWED_VALUES_UPDATE,
  index,
  values,
});

export const updateTypeLabels = (index, typeLabels) => ({
  type: CAMPAIGN_ELEMENT_TYPE_LABELS_UPDATE,
  index,
  typeLabels,
});

export const updateTypeDescriptions = (index, typeDescriptions) => ({
  type: CAMPAIGN_ELEMENT_TYPE_DESCRIPTIONS_UPDATE,
  index,
  typeDescriptions,
});

export function updateDescription(index, description) {
  return {
    type: CAMPAIGN_DESCRIPTION_UPDATE,
    index,
    description,
  };
}

export function updateRequired(index, required) {
  return {
    type: CAMPAIGN_ELEMENT_REQUIRED_UPDATE,
    index,
    required,
  };
}

export function moveElementUp(index) {
  return {
    type: CAMPAIGN_ELEMENT_MOVE_UP,
    index,
  };
}

export function moveElementDown(index) {
  return {
    type: CAMPAIGN_ELEMENT_MOVE_DOWN,
    index,
  };
}

export function setFormDirty() {
  return {
    type: CAMPAIGN_FORM_DIRTY_SET,
  };
}

export function hideVideoLandingPageModal() {
  return {
    type: VIDEO_LANDING_PAGE_MODAL_HIDE,
  };
}

export function showVideoLandingPageModal() {
  return {
    type: VIDEO_LANDING_PAGE_MODAL_SHOW,
  };
}

export function selectImageElementImage(elementIndex, loadedImage) {
  return {
    type: IMAGE_ELEMENT_FILE_SELECT,
    elementIndex,
    loadedImage,
  };
}

export function loadImageElementImage(elementIndex, url) {
  return {
    type: IMAGE_ELEMENT_LOAD_IMAGE,
    elementIndex,
    url,
  };
}

export function editImageElementImage(elementIndex, editMode) {
  return {
    type: IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE,
    elementIndex,
    editMode,
  };
}

export function saveEditedImage(elementIndex, editedImage) {
  return {
    type: IMAGE_ELEMENT_SAVE_EDITED_IMAGE,
    elementIndex,
    editedImage,
  };
}

export function resetImageEditorState(elementIndex) {
  return {
    type: IMAGE_ELEMENT_RESET,
    elementIndex,
  };
}

export function clearVideoElementUploadedVideo(idx) {
  return {
    type: VIDEO_ELEMENT_UPLOADED_STATUS_CLEAR,
    idx,
  };
}

export function completeVideoElementRecording(idx) {
  return {
    type: VIDEO_ELEMENT_RECORDING_COMPLETE,
    idx,
  };
}

export function selectVideo(idx, objectUrl) {
  return {
    type: VIDEO_ELEMENT_VIDEO_SELECT,
    idx,
    objectUrl,
  };
}

export function showCameraRecorder(idx) {
  return {
    type: VIDEO_ELEMENT_CAMERA_RECORDER_SHOW,
    idx,
  };
}

export function hideCameraRecorder(idx) {
  return {
    type: VIDEO_ELEMENT_CAMERA_RECORDER_HIDE,
    idx,
  };
}

export function cancelPostAction(idx) {
  return {
    type: VIDEO_ELEMENT_POST_ACTION_CANCEL,
    idx,
  };
}

export function setIsNewTemplateCreation(value) {
  return {
    type: SET_IS_NEW_TEMPLATE_CREATION,
    value,
  };
}

export function setSeoDescription(value) {
  return {
    type: SEO_SETTINGS_SET_DESCRIPTION,
    value,
  };
}

export function setSeoSiteName(value) {
  return {
    type: SEO_SETTINGS_SET_SITE_NAME,
    value,
  };
}

export function setCepCtaLabel(value) {
  return {
    type: CEP_SET_VLP_CTA_LABEL,
    value,
  };
}

export function setCepCtaLink(value) {
  return {
    type: CEP_SET_VLP_CTA_LINK,
    value,
  };
}

export function addMultipleChoiceOption(index, option) {
  return {
    type: MULTIPLE_CHOICE_ADD_OPTION,
    index,
    option,
  };
}

export function removeMultipleChoiceOption(index, optionIndex) {
  return {
    type: MULTIPLE_CHOICE_REMOVE_OPTION,
    index,
    optionIndex,
  };
}

export function editMultipleChoiceOption(index, optionIndex, newOption) {
  return {
    type: MULTIPLE_CHOICE_EDIT_OPTION,
    index,
    optionIndex,
    newOption,
  };
}

export function reorderMultipleChoiceOptions(index, sourceIndex, destinationIndex) {
  return {
    type: MULTIPLE_CHOICE_REORDER_OPTIONS,
    index,
    sourceIndex,
    destinationIndex,
  };
}

export function updateLanguageSetting(language) {
  return {
    type: LANGUAGE_SETTINGS_SET,
    language,
  };
}

export function updatePublicSubmissionSetting(publicCampaignSubmission) {
  return {
    type: PUBLIC_SUBMISSION_SETTINGS_SET,
    publicCampaignSubmission,
  };
}

export function updateCampaignRewardSettings(rewardSettings) {
  return {
    type: CAMPAIGN_REWARD_SETTINGS_SET,
    rewardSettings,
  };
}

export const fetchGiftCardHistory = (campaignId) =>
  createAction({
    endpoint: `${config.apiHost}/v1/gift-orders?campaignId=${campaignId}`,
    method: 'GET',
    headers: buildHeaders(),
    credentials: 'include',
    types: [
      GIFT_CARD_HISTORY_LOAD,
      GIFT_CARD_HISTORY_LOAD_SUCCESS,
      GIFT_CARD_HISTORY_LOAD_FAILURE,
    ],
  });

export function updateAutoTags(autotags) {
  return {
    type: AUTO_TAGS_SET,
    autotags,
  };
}

export function updateEndDate(endDate) {
  return {
    type: END_DATE_SET,
    endDate,
  };
}

// GET a new PreSigned URL for uploading file to S3
export const createVideoElementPresignedUrl = (mediaPayload, idx) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.preSignCepMediaSubmission}`,
    method: 'POST',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify(mediaPayload),
    types: [
      {
        type: VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_LOAD,
        meta: { idx },
      },
      {
        type: VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_SUCCESS,
        meta: { idx },
      },
      {
        type: VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_FAILURE,
        meta: { idx },
      },
    ],
  });

export const uploadVideoElementToBucket = (file, preSignedUrl, idx) =>
  createAction({
    endpoint: preSignedUrl,
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
    types: [
      {
        type: VIDEO_ELEMENT_BUCKET_UPLOAD_LOAD,
        meta: { idx },
      },
      {
        type: VIDEO_ELEMENT_BUCKET_UPLOAD_SUCCESS,
        meta: { idx },
      },
      {
        type: VIDEO_ELEMENT_BUCKET_UPLOAD_FAIL,
        meta: { idx },
      },
    ],
  });

export const createCampaignSuccessPage = (campaignSuccessPagePayload) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignSuccessPageEndpoint}`,
    method: 'POST',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify(campaignSuccessPagePayload),
    types: [
      CAMPAIGN_SUCCESS_PAGE_CREATE,
      CAMPAIGN_SUCCESS_PAGE_CREATE_SUCCESS,
      CAMPAIGN_SUCCESS_PAGE_CREATE_FAIL,
    ],
  });

export const updateCampaignSuccessPage = (campaignSuccessPagePayload, id) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.campaignSuccessPageEndpoint}/${id}`,
    method: 'PUT',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify(campaignSuccessPagePayload),
    types: [
      CAMPAIGN_SUCCESS_PAGE_UPDATE,
      CAMPAIGN_SUCCESS_PAGE_UPDATE_SUCCESS,
      CAMPAIGN_SUCCESS_PAGE_UPDATE_FAIL,
    ],
  });

export function setMediaType(idx, mediaType) {
  return {
    type: VIDEO_ELEMENT_MEDIA_TYPE_SET,
    idx,
    mediaType,
  };
}

export function showCampaignSuccessModal() {
  return {
    type: CAMPAIGN_SUCCESS_MODAL_SHOW,
  };
}

export function hideCampaignSuccessModal() {
  return {
    type: CAMPAIGN_SUCCESS_MODAL_HIDE,
  };
}

export const resetCampaignTermsState = () => ({
  type: CAMPAIGN_TERMS_RESET,
});

export function clearCsvData() {
  return {
    type: CLEAR_CSV_RESPONSES_DATA,
  };
}

// Campaign Success Page Image Element Actions

// GET a new PreSigned URL for uploading file to S3
export const createCampaignSuccessAssetPresignedUrl = (elementIndex) =>
  createAction({
    endpoint: `${config.apiHost}${config.endpoints.preSignCampaignElementImageForS3}`,
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: [
      CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_LOAD,
      {
        type: CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_SUCCESS,
        meta: { elementIndex },
      },
      {
        type: CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_FAILURE,
        meta: { elementIndex },
      },
    ],
  });

export const uploadCampaignSuccessAssetToBucket = (
  file,
  preSignedUrl,
  elementIndex,
  isV2 = false
) =>
  createAction({
    endpoint: preSignedUrl,
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': 'public-read',
    },
    body: file,
    types: [
      CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_LOAD,
      {
        type: isV2
          ? CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS_V2
          : CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS,
        meta: { elementIndex },
      },
      {
        type: CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_FAIL,
        meta: { elementIndex },
      },
    ],
  });

export const uploadCampaignBrandingAssetToBucket = ({ file, preSignedUrl, isLogo }) =>
  createAction({
    endpoint: preSignedUrl,
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': 'public-read',
    },
    body: file,
    types: [
      { type: CAMPAIGN_BRANDING_BUCKET_UPLOAD_LOAD, meta: { isLogo } },
      {
        type: CAMPAIGN_BRANDING_BUCKET_UPLOAD_SUCCESS,
        meta: { isLogo },
      },
      {
        type: CAMPAIGN_BRANDING_BUCKET_UPLOAD_FAIL,
        meta: { isLogo },
      },
    ],
  });

export function selectCampaignSuccessImageElementImage(elementIndex, loadedImage) {
  return {
    type: CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_FILE_SELECT,
    elementIndex,
    loadedImage,
  };
}

export function loadCampaignSuccessImageElementImage(elementIndex, url) {
  return {
    type: CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_LOAD_IMAGE,
    elementIndex,
    url,
  };
}

export function editCampaignSuccessImageElementImage(elementIndex, editMode) {
  return {
    type: CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE,
    elementIndex,
    editMode,
  };
}

export function saveCampaignSuccessEditedImage(elementIndex, editedImage) {
  return {
    type: CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_SAVE_EDITED_IMAGE,
    elementIndex,
    editedImage,
  };
}

export function resetCampaignSuccessImageEditorState(elementIndex) {
  return {
    type: CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_RESET,
    elementIndex,
  };
}

export function setIsEditedState(elementIndex, editedState) {
  return {
    type: SET_EDITED_STATE,
    editedState,
    elementIndex,
  };
}

export function setFinishedLoadingState(elementIndex) {
  return {
    type: SET_FINISHED_LOADING_STATE,
    elementIndex,
  };
}

// Initial state
const initialState = {
  isLoading: false,
  isLoaded: false,
  isCollectingContacts: null,
  error: false,
  errorMessage: '',
  errorStatus: null,
  isTypesLoading: false,
  isTypesLoaded: false,
  isTypesLoadedError: false,
  isTypesLoadedErrorMessage: '',
  elementTypes: [],
  isSaveLoading: false,
  isSaveSuccess: false,
  isSaveError: false,
  saveErrorMessage: '',
  isDirty: false,
  isVideoLandingPageModalShowing: false,
  data: {
    autotags: [],
    rewardSettings: {
      enabled: false,
      budget: null,
      amount: null,
    },
  },
  elementOptions: [],
  shouldShowCampaignSuccessEditModal: false,
  isTermsUpdateLoading: false,
  hasSuccessfullyUpdatedTerms: false,
  termsData: null,
  shouldShowDownloadResponsesModal: false,
  csvData: null,
  csvFileName: null,
  isLoadingCsvData: false,
  hasCsvDataError: false,
  isNewTemplateCreation: false,
};

// Reducer helpers
function removeElement(index, elements) {
  return elements.filter((el, idx) => idx !== index);
}

function swapLeft(arr, idx) {
  // Make copy so we don't mutate original
  const arrayCopy = arr.slice();

  // if index is 0, we cannot swap left
  if (idx === 0) {
    return arrayCopy;
  }

  // Get reference to element at idx
  const elementToSwap = arrayCopy[idx];
  // Get references to element on left
  const leftElement = arrayCopy[idx - 1];

  // mutate copy
  arrayCopy[idx - 1] = elementToSwap;
  arrayCopy[idx] = leftElement;

  return arrayCopy;
}

function swapRight(arr, idx) {
  // Make copy so we don't mutate original
  const arrayCopy = arr.slice();

  // if index is at last place
  // we don't want to walk off end of array
  if (idx === arr.length - 1) {
    return arrayCopy;
  }

  // Get reference to element at idx
  const elementToSwap = arrayCopy[idx];
  // Get references to element on left
  const rightElement = arrayCopy[idx + 1];

  arrayCopy[idx + 1] = elementToSwap;
  // mutate copy
  arrayCopy[idx] = rightElement;

  return arrayCopy;
}

function reduceLabel(elements, index, label) {
  // Create new pointer in memory
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].label = label;

  return elementsCopy;
}

const reduceAllowedValues = (elements, index, allowedValues) => {
  // Create new pointer in memory
  const elementsCopy = elements.slice();

  elementsCopy[index] = {
    ...elementsCopy[index],
    allowedValues
  };

  return elementsCopy;
};

const reduceTypeLabels = (elements, index, typeLabels) => {
  // Create new pointer in memory
  const elementsCopy = elements.slice();

  elementsCopy[index] = {
    ...elementsCopy[index],
    typeLabels
  };

  return elementsCopy;
};

const reduceTypeDescriptions = (elements, index, typeDescriptions) => {
  const elementsCopy = elements.slice();
  elementsCopy[index] = {
    ...elementsCopy[index],
    typeDescriptions,
  };
  return elementsCopy;
};

function reduceDescription(elements, index, description) {
  // Create new pointer in memory
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].description = description;

  return elementsCopy;
}

function reduceRequired(elements, index, required) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].required = required;

  return elementsCopy;
}

function reduceEditMode(elements, index, editMode) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].editMode = editMode;

  return elementsCopy;
}

function reduceLoadImageState(elements, index, mediaUrl) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].mediaUrl = mediaUrl;
  elementsCopy[index].editMode = false;

  return elementsCopy;
}

function reduceSelectImageState(elements, index, loadedImage) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].loadedImage = loadedImage;
  elementsCopy[index].editMode = true;
  elementsCopy[index].hasEditorChanged = true;
  elementsCopy[index].elementTypeId = elementTypeIds.IMAGE;

  return elementsCopy;
}

function reduceSocialMediaState(elements, socials) {
  const elementsNonSocial =
    elements?.filter((e) => e?.elementTypeId != elementTypeIds.SOCIAL_MEDIA) || [];
  return [...elementsNonSocial, ...socials];
}

function reducePresignedUrl(elements, index, presignedUrl) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].presignedUrl = presignedUrl;
  elementsCopy[index].editMode = false;
  elementsCopy[index].isLoading = true;

  return elementsCopy;
}

function reduceUploadSuccess(elements, index) {
  const prevElementState = elements[index];
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].mediaUrl = getFullMediaUrlFromPresignedUrl(prevElementState.presignedUrl);
  elementsCopy[index].presignedUrl = null;
  elementsCopy[index].loadedImage = null;
  elementsCopy[index].isLoading = false;
  elementsCopy[index].elementTypeId = elementTypeIds.IMAGE;
  return elementsCopy;
}

function reduceUploadError(elements, index, hasUploadError) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].hasUploadError = hasUploadError;
  elementsCopy[index].isLoading = false;
  elementsCopy[index].presignedUrl = null;

  return elementsCopy;
}

function reduceSaveEditedImage(elements, index, editedImage) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].loadedImage = editedImage;
  elementsCopy[index].editMode = false;

  return elementsCopy;
}

function reduceToOriginalState(elements, index) {
  const elementsCopy = elements.slice();

  elementsCopy[index] = elementsCopy[index] || {};
  elementsCopy[index].loadedImage = null;
  elementsCopy[index].editMode = false;
  elementsCopy[index].hasUploadError = false;
  elementsCopy[index].presignedUrl = null;
  elementsCopy[index].mediaUrl = null;

  return elementsCopy;
}

function reduceIsLoadingFinished(elements, index) {
  const elementsCopy = elements.slice();
  elementsCopy[index].finishedLoading = true;

  return elementsCopy;
}

function reduceHasEditorChanged(elements, index, editedState) {
  const elementsCopy = elements.slice();
  elementsCopy[index].hasEditorChanged = editedState;
  return elementsCopy;
}

function reduceAddMultipleChoiceOption(elements, index, option) {
  const elementsCopy = elements.slice();
  const prevChoices = elements[index].choices || [];

  const newChoices = [...prevChoices, option];

  elementsCopy[index].choices = newChoices;
  return elementsCopy;
}

function reduceRemoveMultipleChoiceOption(elements, index, optionIndex) {
  const elementsCopy = elements.slice();
  const prevChoices = elements[index].choices || [];

  const newChoices = prevChoices.filter((opt, idx) => idx !== optionIndex);

  elementsCopy[index].choices = newChoices;
  return elementsCopy;
}

function reduceEditMultipleChoiceOption(elements, index, optionIndex, newOption) {
  const elementsCopy = elements.slice();
  const prevChoices = elements[index].choices || [];
  const newChoices = [...prevChoices];

  newChoices[optionIndex] = newOption;

  elementsCopy[index].choices = newChoices;

  return elementsCopy;
}

function reduceReorderMultipleChoiceOptions(elements, index, sourceIndex, destinationIndex) {
  const elementsCopy = elements.slice();
  const prevChoices = [...elements[index].choices];

  const [removed] = prevChoices.splice(sourceIndex, 1);
  prevChoices.splice(destinationIndex, 0, removed);

  elementsCopy[index].choices = prevChoices;

  return elementsCopy;
}

function mapElementTypes(elementTypes) {
  return elementTypes.map((type) => {
    return {
      label: type.label,
      value: type.id,
    };
  });
}

function normalizeCampaignElements(elements) {
  if (!elements) {
    return [];
  }

  return elements.map((el) => {
    if (el.crakId === crakIds.MULTIPLE_CHOICE || el.crakId === crakIds.AUTOTAG_INPUT) {
      return {
        ...el,
        isDeleted: false,
        choices: el.description.split(','),
      };
    }

    // Initialize allowedValues for Submission Type Selector if not present
    if (el.crakId === crakIds.SUBMISSION_TYPE_SELECTOR) {
      return {
        ...el,
        isDeleted: false,
        allowedValues: el.allowedValues || [SUBMISSION_TYPES.VIDEO, SUBMISSION_TYPES.IMAGE, SUBMISSION_TYPES.TEXT],
        typeLabels: el.typeLabels || {},
        typeDescriptions: el.typeDescriptions || {},
      };
    }

    return {
      ...el,
      isDeleted: false,
    };
  });
}

function reduceDeletedElements(elements, deletedElement) {
  // do not add elements that will cause validation issues
  if (deletedElement.label === '') {
    return elements;
  }

  const deletedElementCopy = {
    ...deletedElement,
    isDeleted: true,
    order: undefined,
    campaignId: undefined,
  };

  return [...elements, deletedElementCopy];
}

export function setEnabled(enabled) {
  return {
    type: CAMPAIGN_SUCESS_PAGE_ENABLED_SET,
    enabled,
  };
}

export function setUseRedirectUrl(useRedirectUrl) {
  return {
    type: CAMPAIGN_SUCESS_PAGE_USE_REDIRECT,
    useRedirectUrl,
  };
}

export function setCampaignSuccessPageValidationError(formValidationResult) {
  return {
    type: CAMPAIGN_SUCESS_PAGE_VALIDATION_ERROR_SET,
    formValidationResult,
  };
}

export function setRedirectUrl(redirectUrl) {
  return {
    type: CAMPAIGN_SUCESS_PAGE_REDIRECT_SET,
    redirectUrl,
  };
}

export function setThankYouSocialUrls(socials) {
  return {
    type: CAMPAIGN_THANK_YOU_SOCIAL_EDIT,
    socials,
  };
}

export function setRedirectUrlV2(redirectUrl) {
  return {
    type: CAMPAIGN_SUCCESS_PAGE_REDIRECT_SET_V2,
    redirectUrl,
  };
}
export function setCampaignSuccessPageRichText(value) {
  return {
    type: SET_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT,
    value,
  };
}
export function initCampaignSuccessPageRichText(value) {
  return {
    type: INIT_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT,
    value,
  };
}

export function setCampaignSubmitState(value) {
  return {
    type: SET_CAMPAIGN_SUBMIT_STATE,
    value,
  };
}

export function hideDownloadResponsesModal() {
  return {
    type: DOWNLOAD_RESPONSES_MODAL_HIDE,
  };
}

export function showDownloadResponsesModal() {
  return {
    type: DOWNLOAD_RESPONSES_MODAL_SHOW,
  };
}

// Reducers
export function campaignEditPageReducer(state = initialState, action) {
  switch (action.type) {
    case CAMPAIGN_FORM_DIRTY_SET: {
      const newState = {
        ...state,
        isDirty: true,
      };

      return newState;
    }

    case CAMPAIGN_EDIT_INFO_LOAD: {
      const newState = {
        ...state,
        isLoading: true,
        isLoaded: false,
        isSaveSuccess: false,
        data: {
          giftcardHistory: state.data?.giftcardHistory || [],
        },
        error: false,
        errorMessage: '',
        errorStatus: null,
        isLoadingGiftCardHistory: false,
      };

      return newState;
    }

    case CAMPAIGN_EDIT_INFO_LOAD_FAILURE: {
      const newState = {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: true,
        errorMessage: action.payload?.response?.message || action.payload?.message || 'Failed to load campaign',
        errorStatus: action.payload?.status,
      };

      return newState;
    }

    case CAMPAIGN_EDIT_INFO_LOAD_SUCCESS: {
      const incoming = action.payload || {};
      const normalizedRewardSettings = incoming.rewardSettings || {
        enabled: false,
        budget: '',
        amount: '',
      };

      const newState = {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: false,
        errorMessage: '',
        errorStatus: null,
        isCollectingContacts: action?.payload?.isCollectingContacts,
        isDirty: false,
        data: {
          ...action.payload,
          useLogo: !!action?.payload?.banner,
          useProfileImage: !!action?.payload?.profileImage,
          campaignSuccessPage: {
            ...action?.payload?.campaignSuccessPage,
            campaignSuccessPageElements:
            action?.payload?.campaignSuccessPage?.campaignSuccessPageElements?.sort(
              (a, b) => a?.sortOrder - b?.sortOrder
            ),
            localRedirectUrl: action?.payload?.campaignSuccessPage?.redirectUrl,
          },
          campaignElements: normalizeCampaignElements(action.payload.campaignElements),
          deletedElements: [],
          seoDescription: action?.payload?.description || '',
          seoSiteName: action?.payload?.siteName || '',
          rewardSettings: normalizedRewardSettings,
          giftcardHistory: state.data?.giftcardHistory || [],
          language: action?.payload?.language,
          autotags: action?.payload?.autotags,
          campaignBranding: {
            ...action?.payload?.campaignBranding,
            ctaLink: action?.payload?.campaignBranding?.ctaLink,
            ctaLabel: action?.payload?.campaignBranding?.ctaLabel,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TYPES_LOAD: {
      const newState = {
        ...state,
        isTypesLoaded: false,
        isTypesLoadedError: false,
        isTypesLoadedErrorMessage: '',
        isTypesLoading: true,
        elementTypes: [],
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TYPES_LOAD_FAILURE: {
      const newState = {
        ...state,
        isTypesLoaded: false,
        isTypesLoadedError: true,
        isTypesLoadedErrorMessage: action?.payload?.response?.message,
        isTypesLoading: false,
        elementTypes: [],
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TYPES_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isTypesLoaded: true,
        isTypesLoadedError: false,
        isTypesLoadedErrorMessage: '',
        isTypesLoading: false,
        elementTypes: mapElementTypes(action.payload.data),
      };

      return newState;
    }

    case CAMPAIGN_NAME_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          name: action.name,
        },
      };

      return newState;
    }

    case CAMPAIGN_BANNER_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            banner: action.banner,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_TITLE_FONT_COLOR_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            fontColor: action.value,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_USE_BANNER_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            useBanner: action.value,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRAND_NAME_EDIT: {
      const prevBrandName = state.data.campaignBranding.name || '';

      const newState = {
        ...state,
        isDirty: hasValueChanged(prevBrandName, action.value),
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            name: action.value,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRAND_TITLE_EDIT: {
      const prevTitle = state.data.campaignBranding.title || '';

      const newState = {
        ...state,
        isDirty: hasValueChanged(prevTitle, action.value),
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            title: action.value,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_LOGO_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            logo: action.logo,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_USE_LOGO_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            useLogo: action.value,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_PROFILE_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            profile: action.profileImage,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_USE_PROFILE_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            useProfile: action.value,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_REDIRECT_SET_V2: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            redirectUrl: action.redirectUrl,
            isDirty: true,
          },
        },
      };
      return newState;
    }

    case SET_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT: {
      const prevRichText = state.data.campaignSuccessPage.richText || '';

      const newState = {
        ...state,
        isDirty: hasValueChanged(prevRichText, action.value),
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            richText: action.value,
            isDirty: true,
          },
        },
      };
      return newState;
    }

    case INIT_CAMPAIGN_SUCCESS_PAGE_RICH_TEXT: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            richText: action.value,
          },
        },
      };
      return newState;
    }

    case SET_CAMPAIGN_SUBMIT_STATE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSubmitState: action.value,
        },
      };
      return newState;
    }

    case CAMPAIGN_ELEMENT_ADD: {
      const { label, campaignElementId, crakId, description, elementTypeId } = action.element;
      const isTermsAndConditions = crakId === crakIds.TERMS_AND_CONDITIONS_INPUT;
      const isSignatureElement = crakId === crakIds.SIGNATURE;
      const isCheckboxElement = crakId === crakIds.GENERIC_CHECKBOX;
      const isSubmissionTypeSelector = crakId === crakIds.SUBMISSION_TYPE_SELECTOR;
      const defaultCampaignElements = state.data.campaignElements || [];
      const isMultipleChoice = crakId === crakIds.MULTIPLE_CHOICE || crakId === crakIds.AUTOTAG_INPUT;

      let elementDescription = isCheckboxElement ? label : '';
      if (isTermsAndConditions) {
        elementDescription = description;
      }
      // Garante que elementTypeId seja preenchido corretamente
      const resolvedElementTypeId = elementTypeId || campaignElementId || crakId;

      // Initialize allowedValues for Submission Type Selector
      const allowedValues = isSubmissionTypeSelector
        ? [SUBMISSION_TYPES.VIDEO, SUBMISSION_TYPES.IMAGE, SUBMISSION_TYPES.TEXT]
        : undefined;

      const campaignElements = [
        ...defaultCampaignElements,
        {
          label: ['Text Response'].includes(label) ? '' : label,
          description: elementDescription,
          elementTypeId: resolvedElementTypeId,
          crakId,
          // default to not required unless it's terms and conditions checkbox ou signature
          required: isTermsAndConditions || isSignatureElement,
          isDeleted: false, // default to not deleted
          choices: isMultipleChoice ? ['Option 1', 'Option 2', 'Option 3'] : [],
          ...(allowedValues && { allowedValues }),
        },
      ];

      // move terms and conditions to bottom of page
      campaignElements.sort(
        (a, b) =>
          CAMPAIGN_ELEMENT_SORT_LIST.indexOf(a.crakId) -
          CAMPAIGN_ELEMENT_SORT_LIST.indexOf(b.crakId)
      );

      const newState = {
        ...state,
        isDirty: ['Short Answer', 'Video'].includes(action.label) ? false : true,
        data: {
          ...state.data,
          campaignElements,
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_DELETE: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          deletedElements: reduceDeletedElements(
            state.data.deletedElements,
            state.data.campaignElements[action.index]
          ),
          campaignElements: removeElement(action.index, state.data.campaignElements),
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_LABEL_UPDATE: {
      const prevElementState = state?.data?.campaignElements[action.index];

      const newState = {
        ...state,
        isDirty: hasValueChanged(prevElementState.label, action.label),
        data: {
          ...state.data,
          campaignElements: reduceLabel(state.data.campaignElements, action.index, action.label),
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_ALLOWED_VALUES_UPDATE: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state?.data,
          campaignElements: reduceAllowedValues(
            state?.data?.campaignElements,
            action.index,
            action.values
          ),
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TYPE_LABELS_UPDATE: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state?.data,
          campaignElements: reduceTypeLabels(
            state?.data?.campaignElements,
            action.index,
            action.typeLabels
          ),
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_TYPE_DESCRIPTIONS_UPDATE: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state?.data,
          campaignElements: reduceTypeDescriptions(
            state?.data?.campaignElements,
            action.index,
            action.typeDescriptions
          ),
        },
      };
      return newState;
    }

    case CAMPAIGN_DESCRIPTION_UPDATE: {
      const prevElementState = state?.data?.campaignElements[action.index];
      const newState = {
        ...state,
        isDirty: hasValueChanged(prevElementState.description, action.description),
        data: {
          ...state.data,
          campaignElements: reduceDescription(
            state.data.campaignElements,
            action.index,
            action.description
          ),
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_REQUIRED_UPDATE: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: reduceRequired(
            state.data.campaignElements,
            action.index,
            action.required
          ),
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_MOVE_UP: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: swapLeft(state.data.campaignElements, action.index),
        },
      };

      return newState;
    }

    case CAMPAIGN_ELEMENT_MOVE_DOWN: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: swapRight(state.data.campaignElements, action.index),
        },
      };

      return newState;
    }

    case CAMPAIGN_FORM_INFO_SAVE: {
      const newState = {
        ...state,
        isSaveLoading: true,
        isSaveSuccess: false,
        isSaveError: false,
      };

      return newState;
    }

    case CAMPAIGN_FORM_INFO_SAVE_FAILURE: {
      const newState = {
        ...state,
        isSaveLoading: false,
        isSaveSuccess: false,
        isSaveError: true,
        saveErrorMessage: action.payload?.response?.message,
      };

      return newState;
    }

    case CAMPAIGN_FORM_INFO_SAVE_SUCCESS: {
      const newState = {
        ...state,
        isSaveLoading: false,
        isSaveSuccess: true,
        isDirty: false,
        data: {
          ...(state.data || {}),
          rewardSettings: state.data?.rewardSettings,
        },
      };

      return newState;
    }

    case VIDEO_LANDING_PAGE_MODAL_HIDE: {
      const newState = {
        ...state,
        isVideoLandingPageModalShowing: false,
      };

      return newState;
    }

    case VIDEO_LANDING_PAGE_MODAL_SHOW: {
      const newState = {
        ...state,
        isVideoLandingPageModalShowing: true,
      };

      return newState;
    }

    case CRAKS_LOAD_SUCCESS: {
      const newState = {
        ...state,
        elementOptions: action.payload.data,
      };

      return newState;
    }

    case CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_SUCCESS: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: reducePresignedUrl(
            state.data.campaignElements,
            action.meta.elementIndex,
            action.payload.presignedUrl
          ),
        },
      };

      return newState;
    }

    case CAMPAIGN_EDIT_PRE_SIGNED_URL_REQUEST_FAILURE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceUploadError(
            state.data.campaignElements,
            action.meta.elementIndex,
            true
          ),
        },
      };

      return newState;
    }

    case CAMPAIGN_EDIT_BUCKET_UPLOAD_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceUploadSuccess(
            state.data.campaignElements,
            action.meta.elementIndex
          ),
        },
      };

      return newState;
    }

    case CAMPAIGN_EDIT_BUCKET_UPLOAD_FAIL: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceUploadError(
            state.data.campaignElements,
            action.meta.elementIndex,
            true
          ),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_VIDEO_SELECT: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.idx) {
              returnValue.videoPreview = action.objectUrl;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_MEDIA_TYPE_SET: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.idx) {
              returnValue.mediaType = action.mediaType;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_FAILURE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.meta.idx) {
              returnValue.isFetchingPresignedUrl = false;
              returnValue.hasSigningError = true;
              returnValue.preSignedUrlData = action.payload;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.meta.idx) {
              returnValue.hasSigningError = false;
              returnValue.preSignedUrlData = action.payload;
              returnValue.isFetchingPresignedUrl = false;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_CAMERA_RECORDER_SHOW: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.idx) {
              returnValue.shouldShowCameraRecorder = true;
              returnValue.preSignedUrlData = null;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_CAMERA_RECORDER_HIDE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.idx) {
              returnValue.shouldShowCameraRecorder = false;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_RECORDING_COMPLETE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.idx) {
              returnValue.hasRecordedVideo = true;
              returnValue.shouldShowPostRecordingActions = true;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_UPLOADED_STATUS_CLEAR: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.idx) {
              returnValue.hasUploadedVideo = false;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_PRESIGNED_URL_REQUEST_LOAD: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };
            if (idx === action.meta.idx) {
              returnValue.isFetchingPresignedUrl = true;
              returnValue.preSignedUrlData = null;
              returnValue.hasPresigningError = false;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_POST_ACTION_CANCEL: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.idx) {
              returnValue.shouldShowPostRecordingActions = false;
              returnValue.shouldShowCameraRecorder = false;
              returnValue.hasUploadFailure = false;
              returnValue.hasSigningError = false;
              returnValue.hasUploadedVideo = false;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_BUCKET_UPLOAD_LOAD: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.meta.idx) {
              returnValue.hasUploadedVideo = false;
              returnValue.hasUploadFailure = false;
              returnValue.isUploading = true;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_BUCKET_UPLOAD_SUCCESS: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.meta.idx) {
              returnValue.hasUploadedVideo = true;
              returnValue.hasUploadFailure = false;
              returnValue.isUploading = false;
              returnValue.shouldShowCameraRecorder = false;
              returnValue.shouldShowPostRecordingActions = false;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case VIDEO_ELEMENT_BUCKET_UPLOAD_FAIL: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: state.data.campaignElements.map((elements, idx) => {
            const returnValue = { ...elements };

            if (idx === action.meta.idx) {
              returnValue.hasUploadedVideo = false;
              returnValue.hasUploadFailure = true;
              returnValue.isUploading = false;
            }

            return returnValue;
          }),
        },
      };

      return newState;
    }

    case IMAGE_ELEMENT_FILE_SELECT: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceSelectImageState(
            state.data.campaignElements,
            action.elementIndex,
            action.loadedImage
          ),
        },
      };

      return newState;
    }

    case IMAGE_ELEMENT_LOAD_IMAGE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceLoadImageState(
            state.data.campaignElements,
            action.elementIndex,
            action.url
          ),
        },
      };

      return newState;
    }

    case IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceEditMode(
            state.data.campaignElements,
            action.elementIndex,
            action.editMode
          ),
        },
      };

      return newState;
    }

    case IMAGE_ELEMENT_SAVE_EDITED_IMAGE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceSaveEditedImage(
            state.data.campaignElements,
            action.elementIndex,
            action.editedImage
          ),
        },
      };

      return newState;
    }

    case IMAGE_ELEMENT_RESET: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceToOriginalState(state.data.campaignElements, action.elementIndex),
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowCampaignSuccessEditModal: true,
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowCampaignSuccessEditModal: false,
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_CREATE_SUCCESS:
    case CAMPAIGN_SUCCESS_PAGE_UPDATE_SUCCESS: {
      const newState = {
        ...state,
        shouldShowCampaignSuccessEditModal: false,
        data: {
          ...state.data,
          campaignSuccessPage: action.payload,
        },
      };
      return newState;
    }

    case CAMPAIGN_SUCESS_PAGE_USE_REDIRECT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            type:
              state.data.campaignSuccessPage.type !== 'NONE'
                ? action.useRedirectUrl
                  ? 'REDIRECT'
                  : 'DESIGN'
                : 'NONE',
            isDirty: true,
          },
        },
      };
      return newState;
    }

    case CAMPAIGN_SUCESS_PAGE_ENABLED_SET: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            type: action.enabled ? 'DESIGN' : 'NONE',
          },
        },
      };
      return newState;
    }

    case CAMPAIGN_SUCESS_PAGE_REDIRECT_SET: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          isDirty: true,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            redirectUrl: action.redirectUrl,
          },
        },
      };
      return newState;
    }

    case CAMPAIGN_THANK_YOU_SOCIAL_EDIT: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          isDirty: true,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
            campaignSuccessPageElements: reduceSocialMediaState(
              state?.data?.campaignSuccessPage?.campaignSuccessPageElements,
              action.socials
            ),
          },
        },
      };
      return newState;
    }

    case CAMPAIGN_SUCESS_PAGE_VALIDATION_ERROR_SET: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            validationError: action.formValidationResult.validationError,
            validationErrorMessage: action.formValidationResult.message,
          },
        },
      };
      return newState;
    }

    // Campaign Success Image Element Reducers
    case CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_FILE_SELECT: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
            campaignSuccessPageElements: reduceSelectImageState(
              state.data.campaignSuccessPage.campaignSuccessPageElements,
              action.elementIndex,
              action.loadedImage
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_LOAD_IMAGE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            campaignSuccessPageElements: reduceLoadImageState(
              state.data.campaignSuccessPage.campaignSuccessPageElements || [],
              action.elementIndex,
              action.url
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_LOAD: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_TOGGLE_EDIT_IMAGE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: action.editMode,
            campaignSuccessPageElements: reduceEditMode(
              state.data.campaignSuccessPage.campaignSuccessPageElements || [],
              action.elementIndex,
              action.editMode
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_SAVE_EDITED_IMAGE: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
            campaignSuccessPageElements: reduceSaveEditedImage(
              state.data.campaignSuccessPage.campaignSuccessPageElements || [],
              action.elementIndex,
              action.editedImage
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_IMAGE_ELEMENT_RESET: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
            campaignSuccessPageElements: reduceToOriginalState(
              state.data.campaignSuccessPage.campaignSuccessPageElements || [],
              action.elementIndex
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_LOAD: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
            campaignSuccessPageElements: reducePresignedUrl(
              state.data.campaignSuccessPage.campaignSuccessPageElements || [],
              action.meta.elementIndex,
              action.payload.presignedUrl
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ...(action.meta.isLogo
              ? {
                  logoPresignUrl: action.payload.presignedUrl,
                  logoLoading: false,
                  logoError: undefined,
                }
              : {
                  profilePresignUrl: action.payload.presignedUrl,
                  profileLoading: false,
                  profileError: undefined,
                }),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_LOAD_IMAGE_FILE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ...(action.isLogo
              ? {
                  logoLoadedImage: action.file,
                }
              : {
                  profileLoadedImage: action.file,
                }),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_LOAD: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ...(action.meta.isLogo
              ? {
                  logoLoading: true,
                }
              : {
                  profileLoading: true,
                }),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRAND_PRE_SIGNED_URL_REQUEST_FAIL: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ...(action.meta.isLogo
              ? {
                  logoError: 'Failed to get presign url for logo',
                }
              : {
                  profileLoading: 'Failed to get presign url for logo',
                }),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_PRE_SIGNED_URL_REQUEST_FAILURE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: false,
            campaignSuccessPageElements: reduceUploadError(
              state.data.campaignSuccessPage.campaignSuccessPageElements || [],
              action.meta.elementIndex,
              true
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: false,
            campaignSuccessPageElements: reduceUploadSuccess(
              state.data.campaignSuccessPage.campaignSuccessPageElements,
              action.meta.elementIndex
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_SUCCESS_V2: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: true,
            campaignSuccessPageElements: reduceUploadSuccess(
              state.data.campaignSuccessPage.campaignSuccessPageElements,
              action.meta.elementIndex
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRANDING_BUCKET_UPLOAD_SUCCESS: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ...(action.meta.isLogo
              ? {
                  logo: getFullMediaUrlFromPresignedUrl(state.data.campaignBranding.logoPresignUrl),
                  logoPresignUrl: undefined,
                  logoLoading: false,
                  logoError: undefined,
                }
              : {
                  profile: getFullMediaUrlFromPresignedUrl(
                    state.data.campaignBranding.profilePresignUrl
                  ),
                  profilePresignUrl: undefined,
                  profileLoading: false,
                  profileError: undefined,
                }),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRANDING_BUCKET_UPLOAD_LOAD: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ...(action.meta.isLogo
              ? {
                  logoLoading: true,
                }
              : {
                  profileLoading: true,
                }),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_BRANDING_BUCKET_UPLOAD_FAIL: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ...(action.meta.isLogo
              ? {
                  logoLoading: false,
                  logoError: 'Failed to upload logo',
                }
              : {
                  profileLoading: false,
                  profileError: 'Failed to upload profile',
                }),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_SUCCESS_PAGE_BUCKET_UPLOAD_FAIL: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignSuccessPage: {
            ...state.data.campaignSuccessPage,
            isDirty: false,
            campaignSuccessPageElements: reduceUploadError(
              state.data.campaignSuccessPage.campaignSuccessPageElements,
              action.meta.elementIndex,
              true
            ),
          },
        },
      };

      return newState;
    }

    case CAMPAIGN_TERMS_FETCH_LOAD: {
      const newState = {
        ...state,
        isTermsFetchLoading: true,
      };

      return newState;
    }

    case CAMPAIGN_TERMS_FETCH_SUCCESS: {
      const newState = {
        ...state,
        isTermsFetchLoading: false,
        termsData: action.payload,
      };

      return newState;
    }

    case CAMPAIGN_TERMS_FETCH_FAILURE: {
      const newState = {
        ...state,
        isTermsFetchLoading: false,
        error: true,
      };

      return newState;
    }

    case CAMPAIGN_TERMS_UPDATE_LOAD: {
      const newState = {
        ...state,
        hasTermsUpdateError: false,
        isTermsUpdateLoading: true,
        hasSuccessfullyUpdatedTerms: false,
      };

      return newState;
    }
    case CAMPAIGN_TERMS_UPDATE_SUCCESS: {
      const newState = {
        ...state,
        isTermsUpdateLoading: false,
        hasSuccessfullyUpdatedTerms: true,
        termsData: action?.payload,
      };

      return newState;
    }
    case CAMPAIGN_TERMS_UPDATE_FAILURE: {
      const newState = {
        ...state,
        hasTermsUpdateError: true,
        isTermsUpdateLoading: false,
        hasSuccessfullyUpdatedTerms: false,
      };

      return newState;
    }

    case CAMPAIGN_TERMS_RESET: {
      const newState = {
        ...state,
        hasTermsUpdateError: false,
        isTermsUpdateLoading: false,
        hasSuccessfullyUpdatedTerms: false,
        termsData: null,
      };

      return newState;
    }

    case DOWNLOAD_RESPONSES_MODAL_SHOW: {
      const newState = {
        ...state,
        shouldShowDownloadResponsesModal: true,
      };

      return newState;
    }

    case DOWNLOAD_RESPONSES_MODAL_HIDE: {
      const newState = {
        ...state,
        shouldShowDownloadResponsesModal: false,
      };

      return newState;
    }

    case CAMPAIGN_CSV_RESPONSES_LOAD: {
      const newState = {
        ...state,
        hasCsvDataError: false,
        isLoadingCsvData: true,
        csvData: null,
        csvFileName: null,
      };

      return newState;
    }

    case CAMPAIGN_CSV_RESPONSES_LOAD_FAIL: {
      const newState = {
        ...state,
        hasCsvDataError: true,
        isLoadingCsvData: false,
        csvData: null,
        csvFileName: null,
      };

      return newState;
    }

    case CAMPAIGN_CSV_RESPONSES_LOAD_SUCCESS: {
      const newState = {
        ...state,
        hasCsvDataError: false,
        isLoadingCsvData: false,
        csvData: action?.payload?.data,
        csvFileName: action?.payload?.fileName,
      };

      return newState;
    }

    case CLEAR_CSV_RESPONSES_DATA: {
      const newState = {
        ...state,
        csvFileName: null,
        csvData: null,
        hasCsvDataError: false,
        isLoadingCsvData: false,
      };

      return newState;
    }

    case SET_EDITED_STATE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceHasEditorChanged(
            state.data.campaignElements,
            action.elementIndex,
            action.editedState
          ),
        },
      };

      return newState;
    }

    case SET_FINISHED_LOADING_STATE: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          campaignElements: reduceIsLoadingFinished(
            state.data.campaignElements,
            action.elementIndex
          ),
        },
      };

      return newState;
    }

    case SET_IS_NEW_TEMPLATE_CREATION: {
      const newState = {
        ...state,
        isNewTemplateCreation: action.value,
      };

      return newState;
    }

    case SEO_SETTINGS_SET_DESCRIPTION: {
      const prevDescription = state.data.seoDescription;
      const newState = {
        ...state,
        isDirty: hasValueChanged(prevDescription, action.value),
        data: {
          ...state.data,
          seoDescription: action.value,
        },
      };

      return newState;
    }

    case SEO_SETTINGS_SET_SITE_NAME: {
      const prevSiteName = state.data.seoSiteName;

      const newState = {
        ...state,
        isDirty: hasValueChanged(prevSiteName, action.value),
        data: {
          ...state.data,
          seoSiteName: action.value,
        },
      };

      return newState;
    }

    case MULTIPLE_CHOICE_ADD_OPTION: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: reduceAddMultipleChoiceOption(
            state.data.campaignElements,
            action.index,
            action.option
          ),
        },
      };

      return newState;
    }

    case MULTIPLE_CHOICE_REMOVE_OPTION: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: reduceRemoveMultipleChoiceOption(
            state.data.campaignElements,
            action.index,
            action.optionIndex
          ),
        },
      };

      return newState;
    }

    case MULTIPLE_CHOICE_EDIT_OPTION: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: reduceEditMultipleChoiceOption(
            state.data.campaignElements,
            action.index,
            action.optionIndex,
            action.newOption
          ),
        },
      };

      return newState;
    }

    case MULTIPLE_CHOICE_REORDER_OPTIONS: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignElements: reduceReorderMultipleChoiceOptions(
            state.data.campaignElements,
            action.index,
            action.sourceIndex,
            action.destinationIndex
          ),
        },
      };

      return newState;
    }

    case LANGUAGE_SETTINGS_SET: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          language: action.language,
        },
      };

      return newState;
    }

    case PUBLIC_SUBMISSION_SETTINGS_SET: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          publicCampaignSubmission: action.publicCampaignSubmission,
        },
      };

      return newState;
    }

    case END_DATE_SET: {
      return {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          endDate: action.endDate,
        },
      };
    }

    case CAMPAIGN_REWARD_SETTINGS_SET: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          rewardSettings: action.rewardSettings || {
            enabled: false,
            budget: '',
            amount: '',
          },
        },
      };

      return newState;
    }

    case GIFT_CARD_HISTORY_LOAD: {
      return {
        ...state,
        isLoadingGiftCardHistory: true,
        data: {
          ...state.data,
          giftcardHistory: [],
        },
      };
    }

    case GIFT_CARD_HISTORY_LOAD_SUCCESS: {
      const giftOrders = action.payload || [];
      const currentCampaignId = deep(state.data, 'campaignId');
      const filteredOrders = currentCampaignId 
        ? giftOrders.filter(order => order.campaignId === currentCampaignId)
        : giftOrders;
      
      const giftcardHistory = filteredOrders.flatMap(order => 
        (order.items || []).map(item => ({
          id: item.id,
          recipientName: item.recipientName,
          recipientEmail: item.recipientEmail,
          amount: item.amount,
          status: item.status,
          sentDate: item.sentAt || item.createdAt,
          giftCode: item.giftCode,
          message: item.message,
          orderId: order.id,
          orderStatus: order.status,
        }))
      );

      return {
        ...state,
        isLoadingGiftCardHistory: false,
        data: {
          ...state.data,
          giftcardHistory,
        },
      };
    }

    case GIFT_CARD_HISTORY_LOAD_FAILURE: {
      return {
        ...state,
        isLoadingGiftCardHistory: false,
        giftCardHistoryError: action.payload?.message || 'Failed to load gift card history',
      };
    }

    case AUTO_TAGS_SET: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          autotags: Array.isArray(action.autotags) ? action.autotags : [],
        },
      };

      return newState;
    }

    case CEP_SET_VLP_CTA_LABEL: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ctaLabel: action.value,
          },
        },
      };

      return newState;
    }

    case CEP_SET_VLP_CTA_LINK: {
      const newState = {
        ...state,
        isDirty: true,
        data: {
          ...state.data,
          campaignBranding: {
            ...state.data.campaignBranding,
            ctaLink: action.value,
          },
        },
      };

      return newState;
    }

    case '@@router/LOCATION_CHANGE': {
      const newState = {
        ...state,
        error: false,
        errorMessage: '',
        errorStatus: null,
      };

      return newState;
    }

    default:
      return state;
  }
}

// Selector helpers
export const toMappedElementOption = (option) => {
  return {
    label: option.label,
    value: option.key,
    role: option.role,
    description: option.description,
    campaignElementId: option.campaignElementId,
    iconClass: option.iconClass,
    crakId: option.crakId,
    order: option?.order,
  };
};

// Selectors
export const getCampaignEditState = createSelector(
  (state) => state,
  (state) => state.get('campaignEdit')
);

export const isCampaignDataLoading = createSelector(
  getCampaignEditState,
  (campaignEditState) =>
    deep(campaignEditState, 'isLoading') || deep(campaignEditState, 'isTypesLoading')
);

export const getCampaignElementOptions = createSelector(
  getCampaignEditState,
  (editState) => editState?.elementOptions
);
// Substitui o selector customizado por uma integração ao fluxo padrão
export const getGenericElementOptions = createSelector(
  getCampaignElementOptions,
  (elementOptions) => {
    const SUBMISSION_TYPE_SELECTOR_ELEMENT_TYPE_ID = 'b7c8d9e0-1234-5678-90ab-cdef12345678';
    const SUBMISSION_TYPE_SELECTOR_CRAK_ID = crakIds.SUBMISSION_TYPE_SELECTOR;
    const alreadyPresent = elementOptions.some(
      (option) => option.value === SUBMISSION_TYPE_SELECTOR_ELEMENT_TYPE_ID
    );
    const genericOptions = elementOptions.filter((option) => option.role === 'Generic');
    if (!alreadyPresent) {
      genericOptions.push({
        label: 'Submission Type Selector',
        value: SUBMISSION_TYPE_SELECTOR_ELEMENT_TYPE_ID,
        role: 'Generic',
        crakId: SUBMISSION_TYPE_SELECTOR_CRAK_ID,
        elementTypeId: SUBMISSION_TYPE_SELECTOR_ELEMENT_TYPE_ID,
        order: 999,
      });
    }
    return genericOptions;
  }
);

export const getCampaignElementOptionLabel = createSelector(
  (state) => getCampaignElementOptions(state),
  (state, elementProps) => elementProps,
  (elementOptions, elementProps) => {
    if (elementProps?.crakId === crakIds.AUTOTAG_INPUT) {
      return 'Autotag Multiple Choice';
    }
  
    // accounting for duplicate crakIds for design elements
    const elementOptionList =
      elementOptions?.filter((opt) => opt?.crakId === elementProps?.crakId) || [];
    if (elementOptionList?.length === 1) {
      return elementOptionList[0]?.label;
    }

    return (
      elementOptionList.find((opt) => opt?.campaignElementId === elementProps?.campaignElementId)
        ?.label || ''
    );
  }
);

// ...duplicado removido, agora apenas a versão que inclui o Submission Type Selector permanece

export const getFilteredGenericElementOptions = createSelector(
  getGenericElementOptions,
  (options) =>
    options
      ?.filter((option) => option.value !== 'GENERIC_TEXT_INPUT')
      ?.sort(
        (a, b) =>
          GENERIC_ELEMENT_SORT_LIST.indexOf(a.value) - GENERIC_ELEMENT_SORT_LIST.indexOf(b.value)
      )
);

export const getDesignElementOptions = createSelector(
  getCampaignElementOptions,
  (elementOptions) => {
    return elementOptions.filter((option) => option.role === 'Design');
  }
);

export const getDesignElementByKey = createSelector(
  (state) => getCampaignElementTypes(state),
  (state, key) => key,
  (elements) => {
    return elements.find((option) => option.label === 'Rich Text');
  }
);

export const getSpecificElementOptions = createSelector(
  getCampaignElementOptions,
  (elementOptions) => {
    return elementOptions.filter((option) => option.role === 'Specific');
  }
);

export const getFilteredSpecificElementOptions = createSelector(
  getSpecificElementOptions,
  (specificElements) =>
    specificElements?.filter(
      (element) =>
        element?.crakId !== crakIds.TERMS_AND_CONDITIONS_INPUT &&
        element?.crakId !== crakIds.SIGNATURE
    )
);

export const getCampaignElementOptionsV2 = createSelector(
  [getSpecificElementOptions, getDesignElementOptions, getGenericElementOptions],
  (specificElements, elementOptions, options) => {
    const excludeCraks = [
      crakIds.TERMS_AND_CONDITIONS_INPUT,
      crakIds.SIGNATURE,
      crakIds.COMPANY,
      crakIds.COUNTRY,
      crakIds.JOB_TITLE,
    ];

    return [
      {
        title: 'Presentation',
        fields: elementOptions,
        info: 'Use these items to add brand elements and instructions to your campaign.',
      },
      {
        title: 'User Info',
        fields: specificElements?.filter((element) => !excludeCraks.includes(element?.crakId)),
        info: 'Collect basic user information about your customers',
      },
      {
        title: 'User Generated Content',
        fields: options
          ?.filter((element) => !excludeCraks.includes(element?.crakId))
          ?.sort((a, b) => a?.order - b?.order),
        info: 'These items can be used to collect any type of content for your campaign',
      },
    ];
  }
);

export const getTermsAndConditionsElementOption = createSelector(
  getSpecificElementOptions,
  (specificElements) =>
    specificElements?.find((element) => element?.crakId === crakIds.TERMS_AND_CONDITIONS_INPUT) ||
    {}
);

export const getTermsSignatureElementOption = createSelector(
  getSpecificElementOptions,
  (specificElements) =>
    specificElements?.find((element) => element?.crakId === crakIds.SIGNATURE) || {}
);

export const getCampaignElementTypes = createSelector(getCampaignEditState, (campaignEditState) =>
  deep(campaignEditState, 'elementTypes')
);

export const getCampaignElementTypesAsMap = createSelector(
  getCampaignElementTypes,
  (elementTypes) =>
    elementTypes.reduce((prev, curr) => {
      return { ...prev, [curr.value]: curr.label };
    }, {})
);

export const getCampaignEditData = createSelector(getCampaignEditState, (campaignEditState) =>
  deep(campaignEditState, 'data')
);

export const getCampaignName = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'name')
);

export const getCampaignBrandingData = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'campaignBranding')
);

export const getCepCtaLabel = createSelector(getCampaignBrandingData, (campaignBrandingData) =>
  deep(campaignBrandingData, 'ctaLabel')
);

export const getCepCtaLink = createSelector(getCampaignBrandingData, (campaignBrandingData) =>
  deep(campaignBrandingData, 'ctaLink')
);

export const getLogoPresign = createSelector(getCampaignBrandingData, (getCampaignBrandingData) =>
  deep(getCampaignBrandingData, 'logoPresignUrl')
);

export const getProfilePresign = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'profilePresignUrl')
);

export const getLogoLoading = createSelector(getCampaignBrandingData, (getCampaignBrandingData) =>
  deep(getCampaignBrandingData, 'logoLoading')
);

export const getProfileLoading = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'profileLoading')
);

export const getLogoError = createSelector(getCampaignBrandingData, (getCampaignBrandingData) =>
  deep(getCampaignBrandingData, 'logoError')
);

export const getProfileError = createSelector(getCampaignBrandingData, (getCampaignBrandingData) =>
  deep(getCampaignBrandingData, 'profileError')
);

export const getLogoLoadedImage = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'logoLoadedImage')
);

export const getProfileLoadedImage = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'profileLoadedImage')
);

//

export const getCampaignBanner = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'banner')
);

export const getUseCampaignBanner = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'useBanner')
);

export const getCampaignLogoUrl = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'logo') || ''
);

export const getUseCampaignLogo = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'useLogo') || ''
);

export const getCampaignProfile = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'profile') || ''
);

export const getUseCampaignProfile = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'useProfile') || ''
);

export const getCampaignBrandName = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'name') || ''
);

export const getCampaignBrandTitle = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'title') || ''
);

export const getCampaignBrandFontColor = createSelector(
  getCampaignBrandingData,
  (getCampaignBrandingData) => deep(getCampaignBrandingData, 'fontColor') || ''
);

export const getCampaignLink = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'campaignLink')
);

export const getCampaignId = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'campaignId')
);

// Only selects campaign elements where isDeleted: false
export const getIsCollectingContacts = createSelector(getCampaignEditState, (campaignEditState) =>
  deep(campaignEditState, 'isCollectingContacts')
);

export const getCampaignElements = createSelector(
  getCampaignEditData,
  (campaignEditData) => deep(campaignEditData, 'campaignElements') || []
);

export const getHasTermsAndConditionsElementOption = createSelector(
  getCampaignElements,
  (campaignEditData) =>
    !!campaignEditData?.find((element) => element?.crakId === crakIds.TERMS_AND_CONDITIONS_INPUT)
);

export const getCampaignEditTermsAndConditionsElement = createSelector(
  getCampaignElements,
  (campaignEditData) =>
    campaignEditData?.find((element) => element?.crakId === crakIds.TERMS_AND_CONDITIONS_INPUT)
);

export const getTermsSignatureCampaignElement = createSelector(
  getCampaignElements,
  (campaignEditData) => campaignEditData?.find((element) => element?.crakId === crakIds.SIGNATURE)
);

export const getCampaignElementsLength = createSelector(
  getCampaignElements,
  (campaignElements) => campaignElements?.length || 0
);

export const getCampaignCreationDate = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'createdAt')
);

export const getDoAllElementsHaveLabels = createSelector(getCampaignElements, (elements) =>
  elements.every((el) => el.label !== '')
);

export const getIsDirty = createSelector(getCampaignEditState, (campaignEditState) =>
  deep(campaignEditState, 'isDirty')
);

export const haveAllVideosBeenUploaded = createSelector(getCampaignElements, (elements) =>
  elements.every((el) =>
    Object.prototype.hasOwnProperty.call(el, 'hasUploadedVideo') ? el.hasUploadedVideo : true
  )
);

export const getCanPublish = createSelector(
  getDoAllElementsHaveLabels,
  getIsDirty,
  haveAllVideosBeenUploaded,
  (allElementsHaveLabels, isDirty, allVideosBeenUploaded) =>
    allElementsHaveLabels && isDirty && allVideosBeenUploaded
);

export const getIsLastElement = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => idx === elements.length - 1
);

export const getIsLastSortableElement = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => {
    const isLastBeforeTerms =
      idx === elements?.length - 2 &&
      elements[idx + 1]?.crakId === crakIds?.TERMS_AND_CONDITIONS_INPUT;
    return idx === elements?.length - 1 || isLastBeforeTerms;
  }
);

export const getIsSaveSuccessful = createSelector(getCampaignEditState, (campaignEditData) =>
  deep(campaignEditData, 'isSaveSuccess')
);

export const getHasSaveError = createSelector(getCampaignEditState, (campaignEditData) =>
  deep(campaignEditData, 'isSaveError')
);

export const getSaveErrorMessage = createSelector(getCampaignEditState, (campaignEditData) =>
  deep(campaignEditData, 'saveErrorMessage')
);

export const getShouldShowVideoLandingPageModal = createSelector(
  getCampaignEditState,
  (campaignEditData) => deep(campaignEditData, 'isVideoLandingPageModalShowing')
);

export const getElementByIndex = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]
);

export const getIsElementRequired = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.required
);

export const getElementHasUploadError = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.hasUploadError
);

export const getElementPresignedUrl = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.presignedUrl
);

export const getElementMediaUrl = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.mediaUrl || null
);

export const getVideoPreview = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.videoPreview || null
);

export const getElementEditMode = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.editMode
);

export const getElementLoadedImage = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.loadedImage
);

export const getElementIsLoading = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.isLoading
);

export const getHasUploadedVideoForIndex = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.hasUploadedVideo
);

export const getPresignedUrlForIndex = createSelector(
  (state, idx) => getElementByIndex(state, idx),
  (element) => deep(element, 'preSignedUrlData.presignedUrl') || null
);

export const getShouldShowCameraRecorder = createSelector(
  (state, idx) => getElementByIndex(state, idx),
  (element) => element?.shouldShowCameraRecorder
);

export const getShouldShowPostRecordingActions = createSelector(
  (state, idx) => getElementByIndex(state, idx),
  (element) => element.shouldShowPostRecordingActions
);

export const getIsVideoElementUploading = createSelector(
  (state, idx) => getElementByIndex(state, idx),
  (element) => element.isFetchingPresignedUrl || element.isUploading
);

export const getElementMedia = createSelector(
  (state, idx) => getElementByIndex(state, idx),
  (element) => element.media
);

export const getShouldShowCampaignSuccessEditModal = createSelector(
  getCampaignEditState,
  (campaignEditData) => deep(campaignEditData, 'shouldShowCampaignSuccessEditModal')
);

export const getCampaignSubmitState = createSelector(
  getCampaignEditData,
  (data) => deep(data, 'campaignSubmitState') || false
);

export const getCampaignSuccessPage = createSelector(
  getCampaignEditData,
  (data) => deep(data, 'campaignSuccessPage') || { campaignSuccessPageElements: [] }
);

export const isCustomSuccessPageEnabled = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'type') !== 'NONE'
);

export const getCampaignSuccessPageType = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'type') || 'DESIGN'
);

export const getCampaignSuccessPageRedirectUrl = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'redirectUrl') || ''
);
export const getCampaignSuccessPageLocalRedirectUrl = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'localRedirectUrl') || ''
);

export const getCampaignSuccessPageRichText = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'richText') || ''
);

export const getCampaignSuccessPageElements = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'campaignSuccessPageElements') || []
);

export const getCampaignSuccessPageId = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'id') || null
);

export const getShouldUseRedirectUrl = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'type') === 'REDIRECT'
);

export const isCampaignSuccessPageEnabled = createSelector(getCampaignSuccessPage, (data) =>
  deep(data, 'enabled')
);

export const isCampaignSuccessPageDirty = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'isDirty') || false
);

export const hasCampaignSuccessPageValidationError = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'validationError')
);

export const getCampaignSuccessPageValidationErrorMessage = createSelector(
  getCampaignSuccessPage,
  (data) => deep(data, 'validationErrorMessage')
);

// Campaign Success Element Selectors
export const getCampaignSuccessElementHasUploadError = createSelector(
  (state) => getCampaignSuccessPageElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.hasUploadError || false
);

export const getCampaignSuccessElementPresignedUrl = createSelector(
  (state) => getCampaignSuccessPageElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.presignedUrl || null
);

export const getCampaignSuccessElementMediaUrl = createSelector(
  (state) => getCampaignSuccessPageElements(state),
  (state, idx) => idx,
  (elements) => {
    const imageElementIndex = elements
      ? elements.findIndex((e) => e?.elementTypeId === elementTypeIds.IMAGE)
      : 1;
    return elements[imageElementIndex]?.mediaUrl || null;
  }
);

export const getCampaignSuccessElementEditMode = createSelector(
  (state) => getCampaignSuccessPageElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.editMode || false
);

export const getCampaignSuccessElementLoadedImage = createSelector(
  (state) => getCampaignSuccessPageElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.loadedImage || null
);

export const getCampaignSuccessElementIsLoading = createSelector(
  (state) => getCampaignSuccessPageElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.isLoading || false
);

export const getIsTermsUpdateLoading = createSelector(
  getCampaignEditState,
  (state) => state?.isTermsUpdateLoading
);

export const getHasTermsUpdateError = createSelector(
  getCampaignEditState,
  (state) => state?.hasTermsUpdateError
);

export const getHasSuccessfullyUpdatedTerms = createSelector(
  getCampaignEditState,
  (state) => state?.hasSuccessfullyUpdatedTerms
);

export const getCampaignTermsData = createSelector(
  getCampaignEditState,
  (state) => state?.termsData
);

export const getShouldShowDownloadResponsesModal = createSelector(
  getCampaignEditState,
  (state) => state?.shouldShowDownloadResponsesModal
);

export const getCsvData = createSelector(getCampaignEditState, (state) => state?.csvData);

export const getCsvFileName = createSelector(getCampaignEditState, (state) => state?.csvFileName);

export const getHasCsvDataError = createSelector(
  getCampaignEditState,
  (state) => state?.hasCsvDataError
);

export const getIsLoadingCsvData = createSelector(
  getCampaignEditState,
  (state) => state?.isLoadingCsvData
);

export const getShouldShowEmptyVideoElementMessage = createSelector(
  (state, idx) => getShouldShowCameraRecorder(state, idx),
  (state, idx) => getVideoPreview(state, idx),
  (state, idx) => getElementMedia(state, idx),
  (shouldShowCameraRecorder, videoPreview, elementMedia) =>
    !(
      shouldShowCameraRecorder ||
      videoPreview ||
      elementMedia?.rawPath ||
      elementMedia?.originalPath
    )
);

export const getHasGetCampaignError = createSelector(getCampaignEditState, (state) => state?.error);

export const getHasGetCampaignErrorMessage = createSelector(
  getCampaignEditState,
  (state) => state?.errorMessage
);

export const getHasGetCampaignErrorStatus = createSelector(
  getCampaignEditState,
  (state) => state?.errorStatus
);

export const getCampaignDomain = createSelector(
  getCampaignEditData,
  (data) => data?.campaignDomain || ''
);

export const getIsUnderCampaignDomainLimit = createSelector(
  getCampaignEditData,
  (data) => data?.isUnderCampaignDomainLimit
);

export const getIsSaveLoading = createSelector(
  getCampaignEditState,
  (state) => state?.isSaveLoading
);

export const getHasEditorChanged = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => {
    return elements[idx]?.hasEditorChanged;
  }
);

export const getHasFinishedLoading = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => {
    return elements[idx]?.finishedLoading;
  }
);

export const getIsNewTemplateCreation = createSelector(getCampaignEditState, (campaignEditData) =>
  deep(campaignEditData, 'isNewTemplateCreation')
);

export const getSeoSiteName = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'seoSiteName')
);

export const getSeoDescription = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'seoDescription')
);

export const getElementMultipleChoiceOptions = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.choices
);

export const getElementAllowedValues = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.allowedValues || [SUBMISSION_TYPES.VIDEO, SUBMISSION_TYPES.IMAGE, SUBMISSION_TYPES.TEXT]
);

export const getElementTypeLabels = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.typeLabels || {}
);

export const getElementTypeDescriptions = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements, idx) => elements[idx]?.typeDescriptions || {}
);

const hasValueChanged = (v1, v2) => {
  return v1 === v2 ? false : true;
};

export const getLanguageSetting = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'language')
);

export const getPublicSubmissionSetting = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'publicCampaignSubmission')
);

export const getEndDate = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'endDate') ?? null
);

export const getIsExpiredAdmin = (state) => {
  const endDate = deep(getCampaignEditData(state), 'endDate');
  return endDate ? new Date() > new Date(endDate) : false;
};

export const getRewardSettings = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'rewardSettings')
);

export const getGiftcardHistory = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'giftcardHistory') || []
);

export const getIsLoadingGiftCardHistory = createSelector(
  getCampaignEditState,
  (campaignEditState) => deep(campaignEditState, 'isLoadingGiftCardHistory') || false
);

export const getLanguageOptions = createSelector(getCampaignEditData, () => getAllLanguages());

export const getAutoTags = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'autotags')
);

export const getCampaignAutotagElement = createSelector(
  (state) => getCampaignElements(state),
  (state, idx) => idx,
  (elements) => {
    const autoTagElement = elements.find((e) => e?.crakId === crakIds.AUTOTAG_INPUT);
    return autoTagElement;
  }
);

export const getCampaignAutotags = createSelector(getCampaignEditData, (campaignEditData) =>
  deep(campaignEditData, 'autotags')
);



// WEBPACK FOOTER //
// ./src/redux/modules/campaigns.js